import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Paper } from '@mui/material'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { useTheme } from '@mui/material/styles'

const BasicDataGrid = ({ rows, columns, width, height, loading, onMounted, styleProps, ...restProps }) => {
  const theme = useTheme()

  useEffect(() => {
    let newTimeout
    if (!loading) {
      newTimeout = setTimeout(onMounted, 500)
    }
    return () => {
      clearTimeout(newTimeout)
    }
  }, [loading])

  const { dataTestId } = restProps
  return (
    <Paper
      elevation={0}
      data-testid={dataTestId}
      sx={{
        width,
        height,
        backgroundColor: theme.palette.background.default,
        '.MuiDataGrid-cell': {
          paddingLeft: `${theme.spacing(2)} !important`,
        },
        ...styleProps,
      }}
    >
      <DataGridPro
        loading={loading}
        autoPageSize
        autoHeight
        rows={rows}
        columns={columns}
        // see https://mui.com/x/react-data-grid/virtualization/#disable-virtualization
        disableVirtualization={process.env.REACT_APP_STAGE === 'test'}
        {...restProps}
      />
    </Paper>
  )
}

BasicDataGrid.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  rows: PropTypes.arrayOf(PropTypes.object),
  width: PropTypes.string,
  height: PropTypes.string,
  loading: PropTypes.bool,
  onMounted: PropTypes.func,
  styleProps: PropTypes.object,
  dataTestId: PropTypes.string,
}

BasicDataGrid.defaultProps = {
  columns: [],
  rows: [],
  width: '100%',
  height: '100%',
  loading: false,
  onMounted: () => {},
  styleProps: {},
  dataTestId: 'datagrid-root',
}

export default BasicDataGrid
